import React from "react";
import styles from "./TagInfo.module.scss";
import classnames from "classnames";
import Text from "../Text/Text";
import { separateBy } from "../../utils/separate-by";

const TagInfo = ({
  gutterBottom,
  className,
  value
}: {
  gutterBottom?: boolean;
  className?: string;
  value: JSX.Element[][];
}) => {
  const parts = value.filter(x => !!x.length).map(p => separateBy(p, ", "));
  return (
    <Text
      className={classnames(styles.root, className, "tags")}
      as="div"
      variant="filterInfo"
      gutterBottom={gutterBottom}
    >
      {separateBy(parts, " | ")}
    </Text>
  );
};

export default TagInfo;
